import i18nFactory from '@yandex-int/i18n';
import { isEqual } from 'lodash';
import * as React from 'react';

import { getDefaultBannerPriceData } from '../../service/BannerHelpers/BannerHelpers';
import { Bem } from '../../service/Bem/Bem';
import { BannersPriceField } from '../../typings/bannerPricesPopupState';
import { BannerPrice, PrefixPrice } from '../../typings/banners';
import { CurrencyCode, GdAdPriceCurrency } from '../../typings/graphql-grid';
import { BannerPriceForm } from '../BannerPriceForm/BannerPriceForm';
import { ErrorItem } from '../ErrorsPresenter/ErrorsPresenter';
import { PopupDecorator } from '../PopupDecorator/PopupDecorator';

import './BannerPriceEditPopup.css';
import * as keyset from './BannerPriceEditPopup.i18n';

const i18n = i18nFactory(keyset);

export interface BannerPriceEditPopupProps {
    bannerPrice: BannerPrice;
    anchor: React.ReactNode;
    errors: ErrorItem[];
    isVisible: boolean;
    isSaveInProgress?: boolean;
    onSave: (bannerPrice: BannerPrice) => void;
    onClearErrors: (isEditInProgress: boolean) => void;
    onCancel: () => void;
    workCurrency: CurrencyCode;
}

export class BannerPriceEditPopup extends React.PureComponent<BannerPriceEditPopupProps, BannerPrice> {
    constructor(props: BannerPriceEditPopupProps) {
        super(props);

        this.state = {
            price: props.bannerPrice.price,
            priceOld: props.bannerPrice.priceOld,
            prefix: props.bannerPrice.prefix ? PrefixPrice[props.bannerPrice.prefix] : PrefixPrice.DEFAULT,
            currency: GdAdPriceCurrency[props.bannerPrice.currency]
        };
    }

    render() {
        const { onCancel, anchor, isVisible, isSaveInProgress } = this.props;

        return (
            <PopupDecorator
                cls={Bem.cls('banner-price-edit-popup')}
                visible={isVisible}
                anchor={anchor}
                target="anchor"
                directions={['bottom-center', 'top-center', 'left-center', 'right-center', 'left-bottom']}
                hasTail={true}
                onOutsideClick={onCancel}
                header={this.getHeader()}
            >
                <BannerPriceForm
                    onResetDraftBannerPrice={() => {
                        this.onResetDraftBannerPrice();
                    }}
                    onCancelBannerPrice={onCancel}
                    onChangeDraftBannerPrice={this.onChangeDraftBannerPrice}
                    hint={false}
                    isOnProgress={isSaveInProgress}
                    bannerPrice={this.state}
                    onChangeBannerPrice={() => {
                        this.onChangeBannerPrice();
                    }}
                    errors={this.props.errors}
                    sizeContent={'m'}
                />
            </PopupDecorator>
        );
    }
    private getHeader = () => i18n('bannerPrice');

    private onChangeDraftBannerPrice = (field: BannersPriceField, value: string) => {
        const errors = this.props.errors;

        this.setState({
            ...this.state,
            [field]: value
        });

        if (errors.length) {
            this.onClearPopupErrors(field, errors);
        }
    };

    private onClearPopupErrors(field: BannersPriceField, errors: ErrorItem[]) {
        const priceField = field === BannersPriceField.PRICE || field === BannersPriceField.PRICE_OLD;

        // в попапе цены одновременно может быть только 1 ошибка
        // при изменение контролов цены или error.path = ''  ошибки удаляются всегда
        if (priceField || !errors[0].path) {
            this.props.onClearErrors(true);
        }

        return;
    }

    // во время сохранения отрабатывает onChangeDraftBannerPrice и onChangeBannerPrice
    // setState - асинсхроннен, в onSave должен уходить свежий стейт
    private onChangeBannerPrice() {
        const { bannerPrice, onSave, onCancel } = this.props;

        setTimeout(() => {
            isEqual(this.state, bannerPrice) ? onCancel() : onSave(this.state);
        }, 0);
    }

    // во время очистки полей отрабатывает onChangeDraftBannerPrice и onResetDraftBannerPrice
    private onResetDraftBannerPrice = () => {
        const { onClearErrors, workCurrency } = this.props;
        setTimeout(() => {
            onClearErrors(true);
            this.setState(getDefaultBannerPriceData(workCurrency));
        }, 0);
    };
}
